import { forwardRef, type InputHTMLAttributes } from 'react';

import { cn } from '@shared/utils';

import { SearchClearIcon } from '../SearchClearIcon/SearchClearIcon';
import { SearchIcon } from '../SearchIcon/SearchIcon';

export interface SearchInputProps extends InputHTMLAttributes<HTMLInputElement> {
  readonly containerClassName?: string;
  readonly onClear?: () => void;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(function SearchInput(
  { className, containerClassName, placeholder, value, onChange, onClear, ...rest },
  ref,
) {
  const hasValue = typeof value === 'string' ? value.length > 0 : false;

  return (
    <div className={cn('relative flex items-center', containerClassName)}>
      <SearchIcon className="pointer-events-none absolute left-2 h-4 w-4 text-[#71767F]" />
      <input
        ref={ref}
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={cn(
          'h-10 w-[248px] rounded-sm border bg-white py-2 pl-8 pr-8 text-sm text-[#111827]',
          'placeholder:text-[#71767F] placeholder:text-[14px] placeholder:font-normal',
          'outline-hidden transition-[border-color,box-shadow]',
          '[&::-webkit-search-cancel-button]:hidden [&::-webkit-search-decoration]:hidden',
          hasValue
            ? 'border-2 border-[#00467D]'
            : 'border border-[#D5D7DA] focus:border-2 focus:border-[#00467D]',
          className,
        )}
        {...rest}
      />
      {hasValue ? (
        <button
          type="button"
          onClick={() => {
            onClear?.();
            if (onChange !== undefined) {
              onChange({ target: { value: '' } } as React.ChangeEvent<HTMLInputElement>);
            }
          }}
          className="absolute right-2 flex items-center justify-center rounded-full hover:opacity-70 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-[#00467D]"
          aria-label="Limpar busca"
        >
          <SearchClearIcon />
        </button>
      ) : null}
    </div>
  );
});
